import { useState } from 'react';
import { useConvexSiteUrl } from './useConvexSiteUrl';

interface UnsubscribeResult {
  success: boolean;
  message: string;
}

export const useUnsubscribe = () => {
  const [isLoading, setIsLoading] = useState(false);
  const convexSiteUrl = useConvexSiteUrl();

  const unsubscribe = async (unsubscribeToken: string): Promise<UnsubscribeResult> => {
    if (!convexSiteUrl) {
      throw new Error('Convex site URL not available');
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${convexSiteUrl}/unsubscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          unsubscribeToken
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
        throw new Error(errorData.error || `HTTP ${response.status}`);
      }

      const result = await response.json();
      return result;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    unsubscribe,
    isLoading
  };
};
